import { Component, OnInit } from '@angular/core';
import { BookingService } from '../../_LOGIC/booking.service';
import { FunctionsService } from 'src/app/_LOGIC/__common/functions.service';

@Component({
  selector: 'app-booking-modal',
  templateUrl: './booking-modal.component.html',
  styleUrls: ['./booking-modal.component.css']
})
export class BookingModalComponent implements OnInit {

  currentBooking;
  subtotal = 0;
  total = 0;

  constructor(private bookingService: BookingService,private commonFuntions: FunctionsService) { }

  ngOnInit(): void {
    this.currentBooking = this.bookingService.getBooking();
    this.subtotal = this.bookingService.calculateSubTotal();
    this.total = this.bookingService.calculateTotal();
    
  }

  getBookingField(field){
    switch(field){
      case 'name':
        return this.currentBooking.clientDetails.name;
      case 'lastname':
        return this.currentBooking.clientDetails.lastname;
      default:
        return '';
    }
  }
}
